import type { ChauffeurPage } from "../slug-chauffeur";

import heroImage from "@/assets/images/chauffeur/services/chauffeur-services.png";

const services: ChauffeurPage = {
  slug: "services",
  title: "Private chauffeur & VTC – Services",
  subtitle: "Premium VTC services and bespoke private chauffeur.",
  keywords: [
    "private chauffeur",
    "VTC",
    "chauffeur service",
    "chauffeur Cannes",
    "VTC Cannes",
  ],
  hero: {
    title: "Private chauffeur & VTC – Services",
    subtitle: "Premium VTC services and bespoke private chauffeur.",
    keywords: ["private chauffeur", "VTC", "premium services"],
    imageSrc: heroImage.src,
    imageAlt: "Private chauffeur – Premium services",
    badges: ["24/7 punctuality", "High-end vehicles", "Expert chauffeurs"],
  },
  benefits: {
    heading: "Why choose our private chauffeurs",
    items: [
      {
        title: "24/7 punctuality",
        description: "Round-the-clock availability and real-time tracking.",
      },
      {
        title: "Premium comfort",
        description: "High-end vehicles with generous space.",
      },
      {
        title: "Local expertise",
        description:
          "Chauffeurs based in Cannes who know the whole French Riviera.",
      },
    ],
  },
  services: {
    heading: "Our VTC services",
    services: [
      {
        title: "Hourly hire",
        text: "Private chauffeur by the hour, half-day or day in Cannes.",
      },
      {
        title: "Airport transfers",
        text: "Nice, Cannes, Monaco – personal welcome, flight tracking.",
      },
      {
        title: "Events",
        text: "Logistics, shuttles, VIP, roadshows in Cannes and on the Riviera.",
      },
      {
        title: "Business",
        text: "Team, client and partner travel across Cannes & Sophia.",
      },
    ],
  },
  locations: {
    heading: "Areas served",
    items: [
      { name: "Cannes" },
      { name: "Nice" },
      { name: "Antibes" },
      { name: "Monaco" },
      { name: "Saint-Tropez" },
      { name: "Italian Riviera" },
      { name: "Milan" },
    ],
  },
  generic: {
    heading: "Excellence & flexibility",
    subheading:
      "Solutions tailored to every trip: transfers, business, events.",
    paragraphs: [
      "Based in Cannes, we coordinate your travel with rigour and discretion, factoring in real timings, sensitive drop-off zones and access constraints.",
      "Across the French Riviera, our network handles specific needs (extended hours, VIP, corporate requirements) without multiplying contacts.",
      "This service suits both one-off use and recurring organisation: transfers, hourly hire, roadshows and event support.",
    ],
    bullets: [
      "24/7 responsiveness",
      "Clear tracking and communication",
      "Suitable fleet (sedan, SUV, van)",
    ],
  },
  process: {
    heading: "Chauffeur services client journey",
    steps: [
      "Quick brief of your need (route, timing, service level).",
      "Proposal of the right service format with a clear estimate.",
      "Validation of the pick-up plan with precise instructions.",
      "On-the-ground execution with tracking through to arrival.",
    ],
  },
  faq: [
    {
      q: "What is the difference between a transfer and hourly hire?",
      a: "A transfer covers a defined trip, whereas hourly hire keeps the vehicle and chauffeur with you over a dedicated time slot.",
    },
    {
      q: "Can you handle several passengers in parallel?",
      a: "Yes, we organise multi-passenger flows with centralised coordination based on your pick-up points.",
    },
    {
      q: "Is the service suited to last-minute requests?",
      a: "Yes, subject to immediate availability. We quickly confirm feasibility and departure times.",
    },
  ],
  relatedLinks: [
    {
      label: "Routes between Riviera towns",
      href: "/en/chauffeur/transfers",
    },
    { label: "Chauffeur for events", href: "/en/chauffeur/events" },
    { label: "Corporate chauffeur service", href: "/en/chauffeur/business" },
  ],
  cta: {
    title: "Get a VTC quote",
    text: "Tell us what you need and we'll respond quickly with a clear offer.",
    primaryHref: "/contact",
    primaryLabel: "Request a quote",
  },
  seo: {
    title: "Private chauffeur & car service – Premium services",
    description:
      "Premium private chauffeur and car service services in Cannes and on the French Riviera: transfers, events, business.",
    canonical: "/en/chauffeur/services",
  },
};

export default services;
